import { render, staticRenderFns } from "./coordinates.vue?vue&type=template&id=510a865e"
import script from "./coordinates.vue?vue&type=script&lang=js"
export * from "./coordinates.vue?vue&type=script&lang=js"
import style0 from "./coordinates.vue?vue&type=style&index=0&id=510a865e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports